import { render, staticRenderFns } from "./templateContentButtonCtaUrl.vue?vue&type=template&id=177ea6fa&"
import script from "./templateContentButtonCtaUrl.vue?vue&type=script&lang=ts&"
export * from "./templateContentButtonCtaUrl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports